<template>
  <VBtn color="error" v-bind="$attrs">
    <slot />
  </VBtn>
</template>
